
import { Component, Vue } from "vue-property-decorator";

const AppProps = Vue.extend({
  props: {
    totalItems: {default: 0},
    pageSize: {default: 20},
    currentPage: {default: 1},
    pageCount: {type: Number},
    showScrollToTop: {default: true},
    disableToTop: {default: false},
  },
})
@Component({
  name: "Pagination",
})
export default class extends AppProps {
  goToPage = 1;

  pageChange(page: number) {
    if(page != this.currentPage) {
      this.$emit('changePage', page)  
      if(!this.disableToTop) {
        this.scrollToTop()
      }
    }   
  }

  handleSizeChange(size:number) {
    if(size != this.pageSize) {
      this.$emit('changeSize', size)
    }
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
